/* APIs */
import MapboxAPI from "../../core/apis/mapBoxApiService/MapboxAPI";
import SearchAPI from "../../search/apis/gemmiciApiService/SearchAPI";
import ShareAPI from "../apis/ShareAPI";
/* Classes */
import Location from "../../core/classes/geo/Location";
import Post from "../../core/classes/Post";
import Picture from "../../core/classes/Picture";
// PLUGINS
import {
  convertMapBoxFeature,
  convertGemmiciLocation
} from "../plugins/ShareConvertor";

export default {
  updateSearchLocationAutocompleteItems(search) {
    // initiate return value
    let destinations = [];
    // GetMapbox items
    MapboxAPI.shareAutocompleteAPI(search).then(response => {
      const mapBoxResult = response.data.features.filter(
        item => item.relevance > 0.5
      ).length;
      // add to destinations all MapBox Items above a relavance of 0.5
      for (let i = 0; i < mapBoxResult; i++) {
        destinations.push(
          new Location(convertMapBoxFeature(response.data.features[i]))
        );
      }
      if (destinations.length < 5) {
        SearchAPI.getGeoInformationsDestinationFromText(search).then(
          response => {
            for (let i = 0; i < 5 - mapBoxResult; i++) {
              if (response.data.features.length < i + 1) {
                break;
              }
              destinations.push(
                new Location(convertGemmiciLocation(response.data.features[i]))
              );
            }
          }
        );
      }
    });
    return destinations;
  },
  getPost(post) {
    return new Post(post);
  },
  getFeature(feature) {
    return new Location(feature);
  },
  getPicture(picture) {
    return new Picture(picture);
  },
  createPostPicture(picture) {
    var payload = new FormData();
    payload.set("name_id", Date.now());
    payload.append("post_picture", picture);
    return ShareAPI.createPostPicture(payload);
  },
  createPost(post) {
    return ShareAPI.createPostAPI(getPostDataForAPI(post, "create"));
  },
  publishPost(nameId) {
    return ShareAPI.publishPostAPI(nameId);
  },
  editPost(post) {
    return ShareAPI.editPostAPI(getPostDataForAPI(post, "edit"));
  },
  deletePost(nameId) {
    return ShareAPI.archivePostAPI(nameId);
  },
  editPicture(picture) {
    return ShareAPI.editPostPicture({
      id: picture.id,
      caption: picture.caption || ""
    });
  }
};
const getPostDataForAPI = (post, step) => {
  let postData = {};
  postData.type = post.type;
  postData.features = post.getDataForCreateOrEditPost();
  postData.theme_names = post.getThemes();
  postData.season = post.season;
  switch (post.type) {
    case "external_link":
    case "youtube":
      postData.url = post.url;
      if (step === "edit") {
        postData.title = post.title;
        postData.picture_ids = post.pictures.map(picture => picture.id);
      }
      break;
    case "short_post":
      postData.content = post.content;
      postData.title = post.title;
      postData.picture_ids = post.pictures.map(picture => picture.id);
      break;
    case "picture_post":
      postData.title = post.title;
      postData.picture_ids = post.pictures.map(picture => picture.id);
      break;
  }
  if (step === "edit") {
    postData.name_id = post.nameId;
    postData.content = post.content;
  }
  return postData;
};
